import axios from 'axios'
import { Message } from 'element-ui';
import Router from '../router/router'

const ax = axios.create({
    baseURL: '', // 动态设置，通过请求拦截器
    timeout: 5000,
    headers: {
        'Content-Type': 'application/json'
    }
});

// 动态设置 base URL 的拦截器
ax.interceptors.request.use(config => {
    if (shouldUseBackendUrl(Router)) {
        config.baseURL = getBackendUrl();
    } else {
        config.baseURL = getFrontendUrl();
    }
    return config;
});

// 动态注入 Token 的拦截器
ax.interceptors.request.use(config => {
    const token = localStorage.getItem("token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// 响应拦截器：处理认证错误，自动跳转到登录页
ax.interceptors.response.use(
    response => response,
    error => {
        const currentPath = Router.currentRoute.path;
        
        // 只在认证错误（401）或token过期时才清除localStorage并跳转登录页
        if (error.response?.status === 401) {
            if (currentPath && currentPath.includes('admin') && !currentPath.includes('login')) {
                Message.error('登录已过期，请重新登录');
                // 清除token
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                // 跳转到登录页
                Router.push('/admin/login').catch(() => {});
            }
        }
        // 其他错误不清除localStorage，让具体的组件处理
        
        return Promise.reject(error);
    }
);

function getBackendUrl() {
    let domain = process.env.VUE_APP_BACKEND_URL?.trim() || '';
    return domain.replace(/\/+$/, ''); // 移除末尾所有斜杠
}

function getFrontendUrl() {
    let domain = process.env.VUE_APP_FRONTEND_URL?.trim() || '';
    return domain.replace(/\/+$/, ''); // 移除末尾所有斜杠
}

function shouldUseBackendUrl(router) {
    const currentPath = router.currentRoute.path;
    return currentPath && currentPath.includes('admin');
}

export default {
    namespaced: true,
    actions: {
        async request({ dispatch }, params) {
            try {
                const response = await ax.request(params);
                if (response.data.code !== 0) {
                    if (response.data.code === 100005) {
                        await dispatch('user/logout', null, { root: true });
                        await Router.push('/');
                    }
                    throw new Error(response.data.msg || '请求异常');
                }
                return response.data;
            } catch (error) {
                handleError(error);
                throw error;
            }
        }
    },
    state: () => ({ ax })
};

function handleError(error) {
    if (error.response?.status === 401) {
        // 401错误已在拦截器中处理，不需要重复显示错误消息
        return;
    }

    // 对于其他错误，不在这里显示消息，让具体的组件处理
    // 这样可以避免重复的错误提示，并让组件有更好的控制权
}